import Vue from 'vue'

const AUTH_ERROR_CODES = new Set([
  'auth/id-token-expired',
  'auth/invalid-custom-token',
  'auth/custom-token-mismatch',
  'auth/user-token-expired',
  'auth/user-disabled',
  'auth/user-not-found',
])

export function isAuthError(error) {
  if (error.response) {
    const status = error.response.status
    if (status === 401 || status === 403) return true
    if (error.response.data && AUTH_ERROR_CODES.has(error.response.data.code)) return true
    if (error.response.data && error.response.data.error === true) return true
  }
  if (AUTH_ERROR_CODES.has(error.code)) return true
  return false
}

function clearAuthStorage() {
  console.log('clearing auth storage');
  ['twoFactorCode', 'firebaseToken', 'vuex', 'm-oauth-token'].forEach(key => {
    window.localStorage.removeItem(key)
  })
  window.indexedDB.deleteDatabase('firebaseLocalStorageDb')
  window.location = window.location.origin
}

export function handleAuthError(error, message) {
  if (isAuthError(error)) {
    clearAuthStorage()
    Vue.prototype.$ApiClient.logout()

  } else {
    Vue.toasted.global.failedRequest({ message })
  }
}
